import * as _ from 'lodash'
import Vue from 'vue'

let mutateEntity = (stateItem, data) => {
  const index = stateItem.findIndex(i => Number(i.id) === Number(data.id))

  if (index === -1) {
    return null
  }
  let newState = _.cloneDeep(stateItem[index])

  if (Object.prototype.hasOwnProperty.call(data, 'additionalParams')) {
    switch (data.additionalParams.fieldToUpdate) {
      case 'approve_master': {
        newState['master-approve'] = data.approve
        newState['master_approve_id'] = Number(data.approve.id)
        break
      }
      case 'approve_status': {
        if (
          !Object.prototype.hasOwnProperty.call(newState, 'approve_status') ||
          !newState.approve_status
        ) {
          Vue.set(newState, 'approve_status', {})
        }
        newState.approve_status[Number(data.additionalParams.inn)] = String(
          data.approve.status,
        )
        break
      }
    }
  }

  return {
    newState,
    index,
  }
}

export { mutateEntity }

export const preparePagination = headers => ({
  currentPage: parseInt(headers['x-pagination-current-page'], 10) || 1,
  pageCount: parseInt(headers['x-pagination-page-count'], 10) || 1,
  perPage: parseInt(headers['x-pagination-per-page'], 10) || 10,
  totalCount: parseInt(headers['x-pagination-total-count'], 10) || 0,
})
